export enum SmsSurveyRoutes {
  index = 'smsSurveys',
  overview = 'smsSurveys.overview',
  details = 'smsSurveys.details',
  detailsOverview = 'smsSurveys.details.overview',
  detailsReplies = 'smsSurveys.details.replies',
  detailsAnalytics = 'smsSurveys.details.analytics',
  viewFlow = 'smsSurveys.viewFlow',
  edit = 'smsSurveys.edit',
}
